<script lang="ts">
	import { afterUpdate } from 'svelte';

	let container: HTMLDivElement;

	export let id: string | undefined;

	afterUpdate(() => {
		if (!id) {
			return;
		}

		container.innerHTML = '';

		/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
		(window as any).sekindoFlowingPlayerOn = false;
		const script = document.createElement('script');
		script.src = 'https://live.primis.tech/live/liveView.php?s=' + id;
		script.defer = true;
		container.appendChild(script);
		return;
	});
</script>

<div class="aspect-16by9 my-4" class:hidden={!id} bind:this={container} />
